import SegmentOrdering from './SegmentOrdering';

export default SegmentOrdering;
